var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgOutlook = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5953_92140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6398 7.21496C13.6406 7.10946 13.5861 7.01127 13.4961 6.9561H13.4946L13.4889 6.95296L8.81372 4.18549C8.79353 4.17185 8.77258 4.15938 8.75096 4.14816C8.57045 4.05503 8.35602 4.05503 8.1755 4.14816C8.15388 4.15939 8.13293 4.17185 8.11274 4.18549L3.43755 6.95296L3.43191 6.9561C3.28902 7.04495 3.24522 7.23283 3.33407 7.37572C3.36025 7.41782 3.39631 7.45289 3.43912 7.4779L8.11433 10.2454C8.13458 10.2589 8.15553 10.2714 8.17708 10.2827C8.3576 10.3758 8.57202 10.3758 8.75254 10.2827C8.7741 10.2714 8.79504 10.2589 8.8153 10.2454L13.4905 7.4779C13.5839 7.42345 13.6409 7.32308 13.6398 7.21496Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98241 5.36714H7.05047V8.17948H3.98241V5.36714ZM13.0121 2.50836V1.2219C13.0195 0.90025 12.7649 0.63344 12.4433 0.625732H4.48163C4.15998 0.63344 3.90539 0.90025 3.91275 1.2219V2.50836L8.61933 3.76345L13.0121 2.50836Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9126 2.50836H7.05031V5.33231H3.9126V2.50836Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.188 2.50836H7.05029V5.33231L10.188 8.15626H13.012V5.33231L10.188 2.50836Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05029 5.33234H10.188V8.15628H7.05029V5.33234Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05029 8.15625H10.188V10.9802H7.05029V8.15625Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98242 8.1795H7.05049V10.7361H3.98242V8.1795Z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.188 8.15625H13.0119V10.9802H10.188V8.15625Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4959 7.46065L13.49 7.46379L8.81476 10.0932C8.79436 10.1057 8.77366 10.1177 8.752 10.1283C8.67259 10.1662 8.58635 10.1875 8.49848 10.1911L8.24306 10.0417C8.22148 10.0309 8.20053 10.0189 8.18031 10.0057L3.44235 7.30157H3.44016L3.28516 7.21497V12.5378C3.28757 12.8929 3.57734 13.1789 3.93246 13.1766H13.0024C13.0077 13.1766 13.0124 13.1741 13.018 13.1741C13.0931 13.1693 13.167 13.1539 13.2377 13.1283C13.2682 13.1154 13.2977 13.1001 13.3259 13.0825C13.3469 13.0706 13.383 13.0445 13.383 13.0445C13.5437 12.9256 13.6388 12.7378 13.6396 12.5378V7.21497C13.6395 7.31678 13.5846 7.41065 13.4959 7.46065Z",
    fill: "url(#paint0_linear_5953_92140)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.3884 7.19395V7.52027L8.49986 10.8861L3.43871 7.30376C3.43871 7.30203 3.4373 7.30063 3.43557 7.30063L2.97119 7.02137V6.78604L3.16259 6.7829L3.56736 7.01509L3.57677 7.01823L3.61128 7.0402C3.61128 7.0402 8.36806 9.75432 8.38061 9.7606L8.5626 9.86728C8.57829 9.861 8.59397 9.85473 8.6128 9.84845C8.62222 9.84217 13.3351 7.1908 13.3351 7.1908L13.3884 7.19395Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4959 7.46065L13.49 7.4641L8.81475 10.0935C8.79436 10.1061 8.77365 10.118 8.75199 10.1286C8.57043 10.2173 8.3581 10.2173 8.17653 10.1286C8.15503 10.118 8.13409 10.1063 8.11378 10.0935L3.43859 7.4641L3.43294 7.46065C3.34268 7.41171 3.28609 7.31764 3.28516 7.21497V12.5378C3.2874 12.8929 3.57706 13.1789 3.93213 13.1766C3.93213 13.1766 3.93214 13.1766 3.93216 13.1766H12.9926C13.3477 13.1789 13.6374 12.8929 13.6396 12.5378C13.6396 12.5378 13.6396 12.5378 13.6396 12.5378V7.21497C13.6395 7.31678 13.5846 7.41065 13.4959 7.46065Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.88277 10.0546L8.8128 10.0938C8.79252 10.1067 8.77157 10.1185 8.75004 10.1292C8.67295 10.1671 8.58913 10.1893 8.50342 10.1945L10.2822 12.298L13.3851 13.0458C13.4701 12.9815 13.5377 12.8971 13.5818 12.8001L8.88277 10.0546Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M9.19968 9.87634L8.8128 10.0938C8.79252 10.1067 8.77157 10.1185 8.75004 10.1292C8.67295 10.1671 8.58913 10.1893 8.50342 10.1945L9.33679 12.4923L13.386 13.0448C13.5455 12.925 13.6395 12.7372 13.6395 12.5378V12.469L9.19968 9.87634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94094 13.1766H12.9917C13.131 13.1773 13.2668 13.1333 13.3792 13.0511L8.24275 10.0424C8.22117 10.0315 8.20021 10.0195 8.17999 10.0063L3.44204 7.30219H3.43984L3.28516 7.21497V12.5196C3.2848 12.8821 3.5784 13.1763 3.94094 13.1766Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.67797 3.71107V10.4038C7.67741 10.6385 7.53472 10.8494 7.31713 10.9372C7.24972 10.9662 7.17713 10.9812 7.10376 10.9812H3.28516V3.44969H3.9127V3.13593H7.10377C7.42075 3.13713 7.67728 3.39408 7.67797 3.71107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.3642 4.02481V10.7176C7.36498 10.7934 7.34891 10.8684 7.31713 10.9372C7.22999 11.152 7.02178 11.2929 6.78999 11.294H3.28516V3.44967H6.78999C6.88103 3.44876 6.97076 3.47147 7.05042 3.51557C7.24276 3.61247 7.36412 3.80944 7.3642 4.02481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.3642 4.02481V10.09C7.36266 10.4069 7.10683 10.6637 6.79 10.6664H3.28516V3.44967H6.78999C6.88103 3.44876 6.97076 3.47147 7.05042 3.51557C7.24276 3.61247 7.36412 3.80944 7.3642 4.02481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.05042 4.02485V10.0901C7.05008 10.4074 6.79355 10.6649 6.47622 10.6665H3.28516V3.44971H6.47621C6.79351 3.44988 7.05059 3.70724 7.05041 4.02454C7.05042 4.02464 7.05042 4.02475 7.05042 4.02485Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.722603 3.44971H6.4753C6.79294 3.44971 7.05044 3.70721 7.05044 4.02485V9.77754C7.05044 10.0952 6.79294 10.3527 6.4753 10.3527H0.722603C0.404958 10.3527 0.147461 10.0952 0.147461 9.77754V4.02485C0.147461 3.70721 0.404965 3.44971 0.722603 3.44971Z",
    fill: "url(#paint1_linear_5953_92140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94514 5.86198C2.0869 5.55996 2.3157 5.30722 2.60219 5.13623C2.91945 4.95459 3.28068 4.86404 3.64611 4.87454C3.9848 4.86719 4.319 4.95305 4.61221 5.12273C4.88789 5.28713 5.10993 5.52802 5.25136 5.81616C5.40539 6.13367 5.48216 6.48309 5.4754 6.83592C5.48286 7.20466 5.40388 7.57002 5.24478 7.90275C5.09997 8.20119 4.87089 8.45066 4.58585 8.62034C4.28134 8.79522 3.93473 8.88334 3.58367 8.87513C3.23774 8.88348 2.89617 8.79665 2.59623 8.62411C2.31816 8.45949 2.09334 8.21833 1.9486 7.92941C1.79366 7.6165 1.71598 7.27101 1.72206 6.92189C1.7156 6.55629 1.79187 6.19396 1.94514 5.86198ZM2.64548 7.56576C2.72106 7.75669 2.84923 7.92228 3.01511 8.04332C3.18406 8.16141 3.38638 8.22233 3.59244 8.21715C3.8119 8.22583 4.02821 8.16283 4.20869 8.03767C4.37247 7.91701 4.49727 7.75097 4.56765 7.56011C4.64632 7.34695 4.68514 7.12116 4.68217 6.89397C4.68461 6.66462 4.64811 6.43651 4.57423 6.21936C4.50899 6.02331 4.38821 5.85043 4.22658 5.72172C4.05062 5.59064 3.83489 5.52415 3.61566 5.53346C3.40513 5.52801 3.19828 5.58941 3.02483 5.70886C2.85615 5.83041 2.72555 5.99746 2.64831 6.19049C2.47695 6.63296 2.47606 7.1233 2.64579 7.56638L2.64548 7.56576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.188 2.50836H13.0119V5.33231H10.188V2.50836Z",
    fill: "#50D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5953_92140",
    x1: 8.4624,
    y1: 7.21497,
    x2: 8.4624,
    y2: 13.1766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5953_92140",
    x1: 1.34665,
    y1: 3.0003,
    x2: 5.85126,
    y2: 10.8021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5953_92140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.4922,
    height: 12.5509,
    fill: "white",
    transform: "translate(0.147461 0.625732)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOutlook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Outlook.884efd7fcca80f103f595eb78c37c553.svg";